import React from "react";
import { List } from "antd-mobile";
import { BaseListItemProps } from "./List.types";
import "./ListItem.scss";

export const ListItem: React.FC<BaseListItemProps> = ({
  title,
  children,
  description,
  prefix,
  extra,
  clickable = true,
  arrowIcon,
  disabled = false,
  onClick,
  // 兼容旧版本
  arrow,
  // 自定义属性
  variant = "primary",
  size = "md",
  className = "",
  testId,
  ...props
}) => {
  // 处理箭头图标，优先使用 arrowIcon，兼容 arrow
  const finalArrowIcon = arrowIcon !== undefined ? arrowIcon : arrow;

  const listItemClass = [
    "list-item",
    `list-item--${variant}`,
    `list-item--${size}`,
    disabled && "list-item--disabled",
    clickable && !disabled && "list-item--clickable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (disabled || !clickable) return;
    onClick?.(e);
  };

  return (
    <List.Item
      className={listItemClass}
      data-testid={testId}
      title={title}
      description={description}
      prefix={prefix}
      extra={extra}
      clickable={clickable && !disabled}
      arrowIcon={finalArrowIcon}
      disabled={disabled}
      onClick={handleClick}
      {...props}
    >
      {children}
    </List.Item>
  );
};

export default ListItem;
